import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  MenuItem,
  TextField,
  Select,
  Chip,
  InputLabel,
  FormControl,
  OutlinedInput,
  Slider,
  Typography,
  Checkbox,
  FormControlLabel,
  RadioGroup,
  Radio,
  IconButton,
} from "@mui/material";
import { useTheme } from "@mui/system";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AdsClickIcon from "@mui/icons-material/AdsClick";
import EventNoteIcon from "@mui/icons-material/EventNote";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

import Fade from "@mui/material/Fade";
// import AdsClickOutlinedIcon from '@mui/icons-material/AdsClickOutlined';

import "./SellDevicePage.scss";
import { IsVisibleContext } from "../App";
import Modal from "@mui/material/Modal";
// import {Card} from "@mui/joy";
import Card from "@mui/material/Card";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import logo from "../assets/img/car_icon_logo_gray.svg";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import manufacturerData from "./../assets/json/manufacturer_models.json";
import axios from "axios";

// Mock data
// const carBrands = ["Audi", "BMW", "Mercedes", "Toyota", "Honda", "Tesla", "Ford"];
// const colors = ["Schwarz", "Weiss", "Grau", "Silber", "Blau", "Grün", "Rot", "Gelb", "Braun"];
const colorMap = {
  Schwarz: "black",
  Weiss: "white",
  Grau: "gray",
  Silber: "silver",
  Blau: "blue",
  Grün: "green",
  Rot: "red",
  Gelb: "yellow",
  Braun: "brown",
};

const caroserieMap = {
  Kombi:
    '<svg viewBox="0 0 100 68" focusable="false" class="chakra-icon css-3lgjdo"><title id="wagonTitle">Wagon icon</title><path fill="currentColor" d="M47 33.45h6l-1 2h-5zM27 33.45h6l-1 2h-5zM19 29.45h43l-2 2H17z"></path><path fill="currentColor" d="m42 25.45 2-2v7h-2z"></path><path fill="currentColor" fill-rule="evenodd" d="M29.788 19.76a397.466 397.466 0 0 1 16.975-.306c4.11.025 9.296 2.154 13.589 4.237 1.938.94 3.737 1.895 5.22 2.68l.523.277c.791.419 1.467.773 2.012 1.04.511.25.842.391 1.02.448 6.63.77 12.309 1.92 16.4 2.945 2.054.514 3.715.998 4.9 1.39.592.195 1.075.37 1.435.518.178.074.34.145.473.214.092.047.302.156.463.327.217.23.325.51.382.688.066.204.114.43.15.648.072.441.114.96.142 1.46.028.506.041 1.018.051 1.45l.005.191c.008.351.014.615.024.774l.005.042.019.121c.017.102.042.231.074.387.056.277.128.614.21.99l.03.144c.185.856.404 1.885.535 2.722.064.405.093.923.093 1.303 0 .506-.34.791-.434.865a1.674 1.674 0 0 1-.37.213c-.202.088-.449.161-.691.224-.498.13-1.163.263-1.857.393-.341.064-.69.127-1.035.19-1.105.202-2.177.397-2.876.582l-.51-1.934c.781-.207 1.974-.424 3.096-.628l.957-.176c.68-.128 1.272-.247 1.693-.355a5.181 5.181 0 0 0-.041-.367c-.121-.771-.328-1.744-.515-2.611l-.032-.147c-.08-.373-.155-.722-.214-1.011a7.17 7.17 0 0 1-.133-.82c-.013-.205-.02-.52-.028-.863l-.004-.183c-.01-.43-.023-.915-.05-1.386a12.324 12.324 0 0 0-.118-1.245 3.454 3.454 0 0 0-.053-.266 6.076 6.076 0 0 0-.201-.086 20.56 20.56 0 0 0-1.302-.47c-1.13-.372-2.742-.843-4.759-1.349-4.031-1.01-9.653-2.148-16.224-2.907l-.069-.008-.067-.017c-.386-.1-.904-.334-1.454-.604a80.775 80.775 0 0 1-2.067-1.068l-.525-.278c-1.485-.787-3.252-1.723-5.156-2.647-4.319-2.096-9.126-4.015-12.728-4.036a395.508 395.508 0 0 0-16.883.303c-5.8.233-10.793.593-12.751 1.058-.152.036-.314.119-.497.271a60.033 60.033 0 0 0-3.93 3.604c-1.42 1.43-2.714 2.912-3.446 4.13-.156.26-.209.357-.232.444-.118.456-.29 1.672-.302 4.203-.002.24-.022.501-.081.769-.111.502-.297 1.19-.553 1.861-.243.634-.588 1.365-1.066 1.88a.777.777 0 0 0 .003.285c.04.302.175.706.395 1.172.431.913 1.079 1.825 1.485 2.263.015.009.064.038.169.08.165.07.4.144.704.221.606.155 1.404.297 2.303.423 1.792.252 3.897.425 5.484.51l-.106 1.997c-1.626-.086-3.79-.264-5.656-.526-.93-.13-1.81-.285-2.519-.465a7.366 7.366 0 0 1-.972-.31c-.26-.107-.59-.27-.835-.53-.56-.591-1.341-1.7-1.865-2.808-.262-.554-.49-1.169-.57-1.759-.076-.568-.04-1.326.506-1.904.208-.22.448-.657.671-1.242.213-.558.374-1.149.469-1.58a1.65 1.65 0 0 0 .034-.346c.012-2.566.182-3.99.367-4.699.102-.39.305-.725.425-.924l.027-.044c.862-1.434 2.297-3.055 3.742-4.51a62.03 62.03 0 0 1 4.067-3.73 3.21 3.21 0 0 1 1.318-.683c2.187-.518 7.399-.88 13.132-1.11M75 47.45H30v-2h45z" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M80.773 40.005a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0M23.772 40.005a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0" clip-rule="evenodd"></path></svg>',
  "SUV / Geländewagen":
    '<svg viewBox="0 0 100 68" focusable="false" class="chakra-icon css-3lgjdo"><title id="suvTitle">SUV icon</title><path fill="currentColor" d="m40 21 2-2v8h-2z"></path><path fill="currentColor" fill-rule="evenodd" d="M45.06 14.751c3.294-.038 6.096.059 7.732.386 3.27.653 6.826 2.843 9.85 4.82.442.29.873.575 1.292.852 1.045.692 2.015 1.333 2.902 1.87 1.272.772 2.213 1.226 2.832 1.337.65.116 1.805.287 3.278.506l1.118.166c1.992.297 4.373.66 6.736 1.065 2.36.405 4.719.856 6.662 1.332.97.237 1.854.485 2.588.74.713.25 1.37.533 1.827.87.506.373.89.906 1.188 1.47.302.573.547 1.236.75 1.935.404 1.398.667 3.038.84 4.595.345 3.12.345 6.051.345 6.357 0 .377-.192.637-.277.739a1.756 1.756 0 0 1-.309.285 4.348 4.348 0 0 1-.641.377c-.468.23-1.085.475-1.744.698-1.29.435-2.93.85-4.079.85H86v-2h1.95c.808 0 2.192-.324 3.44-.745a12.89 12.89 0 0 0 1.497-.596l.11-.057a60.433 60.433 0 0 0-.33-5.687c-.167-1.508-.414-3.02-.773-4.26-.18-.618-.38-1.144-.598-1.557-.222-.42-.433-.667-.605-.794-.205-.15-.624-.355-1.299-.59a27.174 27.174 0 0 0-2.406-.688c-1.875-.459-4.18-.9-6.524-1.303-2.34-.401-4.704-.76-6.693-1.058l-1.098-.163c-1.476-.22-2.673-.397-3.354-.518-1.031-.185-2.265-.836-3.517-1.595-.924-.56-1.945-1.235-3.004-1.936-.412-.272-.83-.548-1.25-.823-3.074-2.01-6.316-3.968-9.145-4.533-1.404-.28-4.008-.386-7.317-.347-3.278.038-7.158.215-11.059.47-7.483.488-14.964 1.256-18.372 1.856a1.847 1.847 0 0 1-.272 2.19l-5.956 6.217a1 1 0 0 0-.276.625l-.445 6.684a2.288 2.288 0 0 1-1.513 2.002.288.288 0 0 0-.191.27v2.568c0 .123.022.236.062.338.155.386.42 1.03.694 1.597.137.285.266.53.375.704l.06.092.055.016c.135.038.316.083.535.135.437.102.994.22 1.571.338 1.154.234 2.362.46 2.804.542.057.01.114.016.175.016H17v2h-3.668c-.18 0-.359-.016-.54-.05-.445-.082-1.667-.31-2.838-.548a59.555 59.555 0 0 1-1.63-.351 15.038 15.038 0 0 1-.619-.157 2.916 2.916 0 0 1-.512-.183 1.588 1.588 0 0 1-.48-.4 3.474 3.474 0 0 1-.278-.391 9.716 9.716 0 0 1-.481-.894c-.303-.63-.59-1.325-.75-1.725A2.907 2.907 0 0 1 5 39.632v-2.566c0-.967.608-1.83 1.518-2.155a.288.288 0 0 0 .19-.251l.446-6.684A3 3 0 0 1 7.98 26.1l5.86-6.116a1.777 1.777 0 0 1-.334-1.58 1.692 1.692 0 0 1 1.331-1.21c3.304-.637 11.232-1.458 19.057-1.969 3.922-.256 7.84-.435 11.166-.474m48.175 27.71-.002.001zM72 46H31v-2h41z" clip-rule="evenodd"></path><path fill="currentColor" d="M46 29h6l-1 2h-5zM28 29h6l-1 2h-5z"></path><path fill="currentColor" fill-rule="evenodd" d="M24 38a6 6 0 1 0 0 12 6 6 0 0 0 0-12m-8 6a8 8 0 1 1 16 0 8 8 0 0 1-16 0M79 38a6 6 0 1 0 0 12 6 6 0 0 0 0-12m-8 6a8 8 0 1 1 16 0 8 8 0 0 1-16 0" clip-rule="evenodd"></path><path fill="currentColor" d="M21 25h41l-2 2H19z"></path></svg>',
  Limousine:
    '<svg viewBox="0 0 100 68" focusable="false" class="chakra-icon css-3lgjdo"><title id="cabrioletTitle">Sedan icon</title><path fill="currentColor" fill-rule="evenodd" d="m74.489 47.12-43-.502.022-2 43 .502z" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M46.443 22.193c-4.384-.154-9.086-.039-12.074.115l-.026.002h-.026c-3.344 0-8.309 1.271-12.957 2.659-1.602.478-3.143.962-4.548 1.404-.617.194-1.209.38-1.768.554-1.791.556-3.314 1.007-4.21 1.145l-.032.005-.032.003h-.004l-.021.002-.09.01a14.666 14.666 0 0 0-1.265.202 2.78 2.78 0 0 0-.017.377c.002.246.022.51.044.808l.012.149c.024.329.051.722.027 1.07-.044.636-.237 1.336-.468 2.004a30.175 30.175 0 0 1-.818 2.05l-.234.538c-.204.469-.394.904-.554 1.303-.228.568-.345.944-.37 1.148-.059.463.103 1.377.405 2.264.145.424.3.775.43 1.002l.04.066 9.739 2.566-.51 1.934L7.27 42.98c-.397-.064-.659-.319-.76-.426a2.876 2.876 0 0 1-.397-.548 7.96 7.96 0 0 1-.59-1.353c-.325-.953-.614-2.227-.497-3.159.061-.492.275-1.087.499-1.645.172-.428.38-.904.588-1.383l.22-.506a28.28 28.28 0 0 0 .764-1.911c.212-.614.337-1.117.363-1.488.012-.182 0-.435-.027-.784l-.01-.136a14.55 14.55 0 0 1-.051-.95c-.004-.356.018-.806.166-1.214.165-.453.526-.936 1.188-1.085a16.404 16.404 0 0 1 1.82-.299h.01c.723-.117 2.071-.509 3.894-1.075.547-.17 1.131-.354 1.745-.546a327.57 327.57 0 0 1 4.592-1.419c4.596-1.372 9.822-2.736 13.503-2.742 3.03-.156 7.78-.272 12.222-.116 2.227.078 4.395.225 6.239.474 1.806.244 3.429.6 4.477 1.156l.01.005 11.519 6.417c4.007.242 9.945.8 15.026 1.713 2.584.463 4.99 1.026 6.82 1.701.91.337 1.725.718 2.355 1.157.61.425 1.188 1.002 1.368 1.778l.026.112v2.765c.26.914.449 2.348.446 3.782-.003 1.483-.209 3.214-.952 4.398l-.218.346-.397.095c-.663.158-1.687.385-2.755.525-1.04.136-2.242.206-3.21-.025l.465-1.946c.594.142 1.49.118 2.486-.012.764-.1 1.515-.252 2.112-.386.31-.714.466-1.794.469-2.999.003-1.38-.195-2.681-.4-3.333l-.046-.146v-2.788c-.05-.1-.188-.281-.538-.525-.433-.302-1.07-.613-1.905-.921-1.664-.615-3.936-1.153-6.48-1.61-5.074-.91-11.057-1.466-15.018-1.698l-.228-.013-11.9-6.63c-.71-.373-2.016-.695-3.8-.936-1.753-.236-3.848-.38-6.04-.457" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M81.227 37.995a6 6 0 1 0 0 12 6 6 0 0 0 0-12m-8 6a8 8 0 1 1 16 0 8 8 0 0 1-16 0M24.654 37.995a6 6 0 1 0 0 12 6 6 0 0 0 0-12m-8 6a8 8 0 1 1 16 0 8 8 0 0 1-16 0" clip-rule="evenodd"></path><path fill="currentColor" d="M22 29.12h41l-2 2H20z"></path><path fill="currentColor" d="m43 25.12 2-2v8h-2zM49 33.12h6l-1 2h-5zM27.27 33.12h6l-1 2h-5z"></path></svg>',
  Cabriolet:
    '<svg viewBox="0 0 100 68" focusable="false" class="chakra-icon css-3lgjdo"><title id="cabrioletTitle">Cabriolet icon</title><path fill="currentColor" fill-rule="evenodd" d="M48.172 20.983c1.195-.15 2.61.098 3.625.636l13.042 6.93 20.033 4.006a7 7 0 0 1 5.628 6.864v3.413a4 4 0 0 1-3.533 3.973l-5.85.688-.234-1.986 5.85-.688a2 2 0 0 0 1.767-1.987V39.42a5 5 0 0 0-4.02-4.903l-20.32-4.064-13.302-7.067c-.63-.334-1.628-.52-2.436-.418-.334.042-.568.125-.713.21.18.138.398.302.642.487.749.563 1.747 1.31 2.747 2.057l2.748 2.047.906.674.343.255-.595.803-.023 1-.976-.022-2.616-.056c-2.188-.047-5.156-.11-8.28-.172C36.35 30.125 29.487 30 27 30c-2.85 0-6.725.333-9.496.616-1.624.165-2.964 1.345-3.365 2.95l-.802 3.21-.52.173h-.002l-.01.003-.041.015a11.017 11.017 0 0 0-.683.265c-.2.086-.402.18-.572.275a2.828 2.828 0 0 0-.17.101c-.006.04-.012.09-.018.147-.03.282-.043.675-.044 1.141 0 .927.053 2.045.108 2.947.04.654.412 1.21.968 1.471.765.36 1.758.786 2.785 1.122 1.041.34 2.049.564 2.862.564 1.302 0 1.924-.004 2.347-.007.541-.004.76-.005 1.667.007l-.028 2c-.892-.012-1.088-.01-1.606-.007-.414.003-1.033.007-2.38.007-1.124 0-2.366-.297-3.483-.663a27.02 27.02 0 0 1-3.014-1.212c-1.255-.59-2.032-1.817-2.114-3.16a53.43 53.43 0 0 1-.112-3.07c0-.49.015-.963.055-1.348.02-.19.048-.387.095-.565.033-.13.12-.443.365-.69.224-.223.508-.401.745-.533.252-.14.52-.264.756-.366.13-.055.254-.105.365-.149l.54-2.162c.6-2.401 2.618-4.203 5.103-4.456C20.076 28.343 24.039 28 27 28c2.513 0 9.4.125 15.645.25a6203.98 6203.98 0 0 1 8.743.182l-1.487-1.109c-1-.746-2.001-1.495-2.753-2.062a136.632 136.632 0 0 1-1.182-.902 3.603 3.603 0 0 1-.158-.135 1.026 1.026 0 0 1-.167-.21l-.002-.004c-.02-.032-.14-.23-.14-.51 0-.797.361-1.432.914-1.857.516-.396 1.158-.584 1.76-.66m-36.8 16.471s-.002.009-.008.022a.154.154 0 0 1 .008-.022M54.5 29.5l-.023 1 3.14.07-2.522-1.873z" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="m33.984 47.227.031-2c10.782.166 24.808.39 35 .554l-.03 2z" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M28 40a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0M75 40a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0" clip-rule="evenodd"></path><path fill="currentColor" d="M45 33h6l-1.091 2h-4.91z"></path></svg>',
  Coupé:
    '<svg viewBox="0 0 100 68" focusable="false" class="chakra-icon css-3lgjdo"><title id="coupeTitle">Coupe icon</title><path fill="currentColor" d="M41 35h6l-1 2h-5z"></path><path fill="currentColor" fill-rule="evenodd" d="M38.553 22.499c6.812-.673 12.667-.552 14.936-.294 1.24.141 2.81.654 4.42 1.3 1.632.655 3.385 1.481 5.016 2.3 1.634.82 3.157 1.639 4.33 2.283.594.325 1.085.598 1.458.806.347.193.59.329.72.396.015.005.055.016.128.033.131.029.313.063.55.1.47.077 1.102.163 1.86.26.474.061.996.127 1.551.196 1.212.151 2.588.323 3.994.517 2.053.282 4.203.614 6.062 1.004 1.817.381 3.494.844 4.506 1.436 1.076.629 1.832 1.62 2.366 2.678.535 1.06.879 2.249 1.103 3.363.447 2.222.447 4.301.447 4.819v.003c0 .365-.166.638-.308.802-.138.16-.299.273-.427.35a4.316 4.316 0 0 1-.88.372c-.626.2-1.446.379-2.28.534-.842.158-1.736.3-2.524.422l-.37.057c-.636.098-1.168.18-1.528.247l-.366-1.966c.394-.073.964-.161 1.597-.259l.36-.056c.787-.122 1.655-.26 2.464-.41.818-.153 1.536-.313 2.037-.473.086-.028.16-.054.222-.077-.014-.806-.08-2.355-.405-3.97-.203-1.012-.501-2.011-.928-2.857-.427-.848-.955-1.482-1.59-1.853-.697-.408-2.074-.82-3.906-1.205-1.79-.375-3.886-.7-5.925-.98-1.394-.192-2.746-.36-3.952-.511-.56-.07-1.088-.136-1.574-.199a63.306 63.306 0 0 1-1.927-.27c-.252-.04-.478-.08-.664-.122a2.481 2.481 0 0 1-.57-.186c-.139-.071-.452-.245-.887-.487-.378-.21-.847-.471-1.375-.76a134.307 134.307 0 0 0-4.266-2.25c-1.606-.805-3.304-1.604-4.864-2.23-1.58-.635-2.942-1.06-3.901-1.17-2.09-.237-7.797-.366-14.513.297-6.72.663-14.333 2.108-20.292 4.957-.314.15-.65.247-1 .285-.854.092-2.031.238-3.08.405-.524.084-1.005.17-1.392.258a7.104 7.104 0 0 0-.48.122 2.75 2.75 0 0 0-.128.042 2.56 2.56 0 0 0-.146.212 9.046 9.046 0 0 0-.54 1.043 20.74 20.74 0 0 0-1.169 3.429c-.329 1.328-.542 2.74-.522 4.052.021 1.319.277 2.46.813 3.314.054.086.186.195.438.244l8.442 1.667-.388 1.962-8.441-1.666c-.631-.125-1.321-.468-1.746-1.144-.8-1.276-1.093-2.82-1.117-4.346-.024-1.534.223-3.125.58-4.565a22.736 22.736 0 0 1 1.286-3.77c.226-.5.454-.94.67-1.282.106-.17.22-.333.338-.473.101-.12.273-.305.511-.426.309-.158.752-.275 1.162-.367.444-.1.97-.194 1.515-.281a68.26 68.26 0 0 1 3.179-.419c.121-.013.24-.046.353-.1 6.267-2.997 14.149-4.472 20.957-5.143M90.25 43.127l-.003.002zM72 47.199H32v-2h40z" clip-rule="evenodd"></path><path fill="currentColor" d="M25.95 31H63l-2 2H24z"></path><path fill="currentColor" d="M37 28.064 39 26v7h-2z"></path><path fill="currentColor" fill-rule="evenodd" d="M25.75 40a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0M77.522 40a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0" clip-rule="evenodd"></path></svg>',
  Kleinwagen:
    '<svg viewBox="0 0 100 68" focusable="false" class="chakra-icon css-3lgjdo"><title id="smallCarTitle">Small-car icon</title><path fill="currentColor" fill-rule="evenodd" d="M26.958 21.957c6.38-.344 18.008-.957 23.4-.957 3.049 0 6.833 1.593 10.387 3.444 2.34 1.219 4.705 2.62 6.79 3.855 1.094.649 2.112 1.252 3.008 1.759a1 1 0 0 0 .13.06l10.93 4.16a3 3 0 0 1 1.645 1.525L84 37.396a3 3 0 0 1 .197.552l.392 1.57a3 3 0 0 1 .09.728V45.5a2.5 2.5 0 0 1-2.5 2.5h-4.5v-2h4.5a.5.5 0 0 0 .5-.5v-5.254a1 1 0 0 0-.03-.242l-.393-1.571a1 1 0 0 0-.065-.184l-.752-1.593a1 1 0 0 0-.548-.508l-10.929-4.16a3 3 0 0 1-.403-.19c-.965-.545-2.017-1.17-3.13-1.829-2.05-1.215-4.307-2.553-6.608-3.752C56.254 24.36 52.864 23 50.358 23c-5.325 0-16.885.608-23.292.954a1 1 0 0 0-.692.336l-6.623 7.506c-.106.12-.181.264-.22.42l-.829 3.313c-.054.215-.13.415-.217.6a17 17 0 0 0-1.291 3.965c-.293 1.575-.281 3.066.22 4.153a.5.5 0 0 0 .16.17c.108.08.235.13.367.146l3.679.444-.24 1.986-3.678-.444a2.8 2.8 0 0 1-1.314-.521 2.47 2.47 0 0 1-.789-.942c-.76-1.647-.692-3.634-.371-5.357a19 19 0 0 1 1.452-4.463 1.2 1.2 0 0 0 .082-.221l.828-3.315a3 3 0 0 1 .661-1.257l6.623-7.506a3 3 0 0 1 2.084-1.01M66.858 48H32.5v-2h34.358z" clip-rule="evenodd"></path><path fill="currentColor" d="M47 34h6l-1 2h-5zM30 34h6l-1 2h-5z"></path><path fill="#currentColor" fill-rule="evenodd" d="M26.857 41a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m-6.5 4.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0M72.857 41a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m-6.5 4.5a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0" clip-rule="evenodd"></path><path fill="currentColor" d="M27 30h37l-2 2H25z"></path><path fill="currentColor" d="m43 27 2-2v7h-2z"></path></svg>',
  "Pick-up":
    '<svg viewBox="0 0 100 68" focusable="false" class="chakra-icon css-3lgjdo"><title id="pickUpTitle">Pick-up icon</title><path fill="currentColor" d="M53 32.355h6l-1 2h-5zM37 32.355h6l-1 2h-5zM39 27.354h30l-2 2H37z"></path><path fill="currentColor" d="m50 22.355 2-2v9h-2z"></path><path fill="currentColor" fill-rule="evenodd" d="M26 38a6 6 0 1 0 0 12 6 6 0 0 0 0-12m-8 6a8 8 0 1 1 16 0 8 8 0 0 1-16 0M81 38a6 6 0 1 0 0 12 6 6 0 0 0 0-12m-8 6a8 8 0 1 1 16 0 8 8 0 0 1-16 0" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M36.452 19.323c-.116.166-.267.447-.426.887-.229.63-.425 1.435-.585 2.326-.321 1.778-.48 3.778-.518 5.132l-.027 1.012-27.94-1.114c-.938 1.637-1.111 3.83-.84 6.097.265 2.202.931 4.315 1.522 5.726l11.081 2.49-.438 1.952L6.22 41.12l-.206-.453c-.702-1.54-1.56-4.08-1.883-6.766-.32-2.658-.137-5.66 1.477-7.937l.314-.442 27.046 1.079a38.3 38.3 0 0 1 .504-4.421c.171-.948.391-1.875.674-2.653.265-.732.648-1.514 1.248-1.971l.237-.18.296-.022c3.791-.277 9.598-.383 14.828-.178 2.615.103 5.106.284 7.14.564 1.016.14 1.935.307 2.707.507.75.194 1.443.44 1.948.772.495.326 1.073.701 1.698 1.108 1.456.947 3.172 2.064 4.727 3.122a63.302 63.302 0 0 1 2.985 2.137c.413.319.78.621 1.078.895.14.129.282.266.41.408 2.677.282 6.565.758 10.036 1.32 1.827.297 3.556.62 4.939.957.69.168 1.311.343 1.822.525.482.172.971.385 1.314.667l.056.045.048.053c2.552 2.8 4.465 8.622 1.637 13.768l-.228.417-4.892.897-.36-1.967 3.941-.723c1.988-4.092.5-8.706-1.514-10.975-.091-.059-.297-.164-.673-.298-.42-.15-.968-.306-1.624-.466-1.31-.318-2.98-.632-4.786-.925-3.609-.585-7.688-1.077-10.342-1.35l-.495-.05-.258-.425-.001-.003-.005-.007a1.618 1.618 0 0 0-.097-.118 4.463 4.463 0 0 0-.281-.278c-.24-.22-.56-.485-.949-.786a61.494 61.494 0 0 0-2.887-2.064 272.843 272.843 0 0 0-4.668-3.084c-.632-.41-1.22-.793-1.73-1.13-.227-.148-.661-.328-1.35-.506-.67-.174-1.506-.328-2.479-.462-1.943-.267-4.363-.445-6.945-.546-4.992-.196-10.513-.104-14.225.147" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="m73.976 46.355-41-1 .048-2 41 1z" clip-rule="evenodd"></path></svg>',
  "Kompaktvan / Minivan":
    '<svg viewBox="0 0 100 68" focusable="false" class="chakra-icon css-3lgjdo"><title id="miniVanTitle">Minivan icon</title><path fill="currentColor" fill-rule="evenodd" d="M47.565 17.087h-.004l-.044-.007a62.405 62.405 0 0 0-.827-.104c-.569-.07-1.394-.164-2.423-.268-2.057-.207-4.93-.449-8.2-.59-6.513-.28-14.698-.165-21.125 1.482l-.02.005-.019.006-.011.003-.026.008-.17.054-1.345.429a1 1 0 0 0-.341 1.717c-.574.776-1.267 1.724-1.96 2.693a93.664 93.664 0 0 0-2.314 3.358c-.317.49-.593.939-.793 1.306-.1.183-.19.363-.257.527-.052.127-.15.378-.15.652 0 .269.031.819.068 1.453l.005.096c.04.697.088 1.53.12 2.345.031.82.046 1.6.023 2.195a5.692 5.692 0 0 1-.057.683 9.787 9.787 0 0 0-1.427 2.061c-.103.214-.268.583-.268.957v1.958c0 .292.105.535.174.673.08.159.18.31.281.445.203.273.469.559.75.828.55.526 1.278 1.094 1.923 1.403.338.161.957.365 1.632.568.703.21 1.548.444 2.39.66.84.217 1.687.42 2.394.569.662.14 1.314.258 1.694.258v-2c-.131 0-.567-.064-1.28-.215a56.67 56.67 0 0 1-2.31-.548 62.814 62.814 0 0 1-2.313-.64c-.7-.21-1.17-.373-1.344-.457-.379-.18-.93-.591-1.404-1.044a4.997 4.997 0 0 1-.53-.58 1.756 1.756 0 0 1-.057-.08v-1.725c.009-.024.028-.074.068-.156.079-.164.199-.37.345-.594.302-.461.637-.879.813-1.047.205-.195.297-.427.339-.547.05-.144.082-.293.104-.427.045-.271.07-.593.082-.927.025-.675.008-1.516-.024-2.349-.032-.836-.081-1.687-.121-2.382a58.112 58.112 0 0 1-.069-1.33c.03-.071.083-.18.163-.327.164-.302.408-.702.715-1.175a91.721 91.721 0 0 1 2.261-3.281 234.165 234.165 0 0 1 3.101-4.226c6.08-1.49 13.85-1.61 20.204-1.336 3.223.139 6.058.377 8.086.581a118.882 118.882 0 0 1 3.183.365l.04.005.023.003.01.001.364.044a387.17 387.17 0 0 1 4.073.515c2.369.314 4.85.672 5.667.885-.023-.006-.023-.006.019.01a60.333 60.333 0 0 1 .898.368c.596.25 1.42.599 2.392 1.015 1.946.833 4.485 1.928 7.007 3.02a5352.834 5352.834 0 0 1 9.157 3.974l.855.372.4-.917-.4.917.066.029.07.019.264-.965-.264.965.572.157a741.91 741.91 0 0 1 6.147 1.727c1.696.487 3.403.987 4.714 1.395.657.204 1.205.382 1.6.522.123.044.226.082.31.114.2.499.468 1.327.719 2.19.149.516.284 1.016.385 1.42a16.739 16.739 0 0 1 .156.687l.009.052.002.015v.006c.057.517.043 1.82 0 2.3-.018.187-.157.954-.35 1.726a10.25 10.25 0 0 1-.283.97 3.19 3.19 0 0 1-.04.105c-.626.277-1.576.576-2.57.82-1.03.252-3.252.47-5.262.471v2c2.085-.001 4.487-.222 5.738-.529 1.162-.285 2.4-.672 3.21-1.077.202-.101.333-.243.401-.328.077-.093.135-.189.179-.269.087-.159.161-.338.223-.508.125-.343.244-.764.345-1.17.199-.797.368-1.684.4-2.028.053-.578.072-2.018-.002-2.699-.025-.23-.114-.623-.215-1.028-.108-.432-.25-.957-.405-1.492-.3-1.035-.682-2.224-.98-2.82l-.078-.155-.126-.12a1.374 1.374 0 0 0-.308-.216 3.125 3.125 0 0 0-.23-.108 10.041 10.041 0 0 0-.56-.214c-.432-.153-1.01-.34-1.674-.547-1.333-.415-3.056-.92-4.757-1.407a632.324 632.324 0 0 0-6.166-1.733l-.507-.139-.79-.344a5613.179 5613.179 0 0 0-9.16-3.976 1961.974 1961.974 0 0 0-7.015-3.023c-.975-.416-1.803-.769-2.407-1.022-.302-.126-.55-.229-.735-.303a4.624 4.624 0 0 0-.45-.165c-.968-.251-3.605-.627-5.91-.932a379.22 379.22 0 0 0-4.094-.517zm43.883 16.242a.126.126 0 0 1-.003-.002zM7.962 39.884a.084.084 0 0 1 .001.001z" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M28.95 45.999 29.011 44l22.286.262c7.262-.029 14.444-.05 20.252.24l-.062 1.998-20.197-.238-.468.002-.353.002c-7.546.03-15.202.055-21.52-.267" clip-rule="evenodd"></path><path fill="currentColor" d="M50 32h6l-1 2h-5zM30 32h6l-1.2 2H30zM43 23l2-2v8h-2z"></path><path fill="currentColor" d="M22 28h45l-2 2H20z"></path><path fill="currentColor" fill-rule="evenodd" d="M23 40a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0M78 40a5 5 0 1 0 0 10 5 5 0 0 0 0-10m-7 5a7 7 0 1 1 14 0 7 7 0 0 1-14 0" clip-rule="evenodd"></path></svg>',
  Bus: '<svg viewBox="0 0 100 68" focusable="false" class="chakra-icon css-3lgjdo"><title id="vanTitle">Van icon</title><path fill="currentColor" d="M55 29h6l-1 2h-5zM15 25h60l-2 2H13z"></path><path fill="currentColor" d="m51 18 2-2v11h-2zM29 18l2-2v11h-2z"></path><path fill="currentColor" fill-rule="evenodd" d="M20.162 38a6 6 0 1 0 0 12 6 6 0 0 0 0-12m-8 6a8 8 0 1 1 16 0 8 8 0 0 1-16 0M81.162 38a6 6 0 1 0 0 12 6 6 0 0 0 0-12m-8 6a8 8 0 1 1 16 0 8 8 0 0 1-16 0" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="m73.979 47-47-1 .042-2 47 1z" clip-rule="evenodd"></path><path fill="currentColor" fill-rule="evenodd" d="M10.708 14.695c-.002.002-.002.002 0 0-.415.43-.83 1.235-1.197 2.4-.359 1.137-.639 2.505-.852 3.95-.426 2.892-.57 5.991-.57 7.955v5.657l-.482 1.5v4.137l-1.18 1.83-.068.07c-.21.218-.296.383-.331.485a.38.38 0 0 0-.022.204c.01.049.032.098.06.144l7.002.475-.136 1.996-7.634-.519-.226-.156a2.518 2.518 0 0 1-1.03-1.556c-.154-.794.106-1.625.807-2.386l.758-1.175v-3.863l.483-1.5V29c0-2.036.147-5.237.59-8.246.222-1.504.521-2.986.924-4.261.393-1.248.921-2.417 1.666-3.188.318-.329.874-.645 1.591-.88.746-.245 1.738-.425 2.993-.425h.01l48.308.5h.005c1.004 0 2.399.221 3.727.586 1.315.36 2.715.902 3.645 1.624l.026.02 10.027 8.894 10.995 3.957.058.03c.742.385 1.788 1.122 2.559 2.133.748.982 1.306 2.329.892 3.863l.82.849.073.196c.425 1.146.917 2.952.991 4.667.07 1.612-.215 3.67-1.952 4.57-.658.34-1.693.85-2.668 1.277-.486.213-.972.412-1.395.56-.376.13-.844.274-1.229.274H87.14v-2h1.6c-.005 0 .037-.003.142-.03.112-.027.258-.071.435-.133.354-.123.787-.3 1.25-.503.926-.406 1.92-.896 2.552-1.222.581-.301.94-1.16.873-2.706-.059-1.355-.438-2.843-.798-3.865l-1.1-1.137v-1.061l.049-.15c.252-.783.02-1.528-.52-2.237-.532-.698-1.288-1.247-1.831-1.539l-11.229-4.041L68.3 16.27c-.62-.47-1.702-.922-2.924-1.257-1.22-.334-2.432-.514-3.203-.514h-.01L13.853 14h-.005c-1.062 0-1.84.153-2.365.325-.264.087-.46.177-.595.252-.117.065-.17.11-.181.118" clip-rule="evenodd"></path></svg>',
};

const transmissions = ["Automat", "Schaltgetriebe"];
const fuelTypes = ["Benzin", "Diesel", "Hybrid", "Elektro"];
// const carBrands = ["Audi", "WW", "BMW", "Mercedes", "Toyota", "Ford"];
const carModels = manufacturerData;

const CarPurchaseForm = () => {
  const { isVisibleHeader, setIsVisibleHeader } = useContext(IsVisibleContext);
  const [step, setStep] = useState(() => {
    const savedStep = sessionStorage.getItem("step");
    return savedStep !== null ? parseInt(savedStep, 10) : 0;
  });
  const initialFormData = {
    selectedCars: [],
    priceRange: [0, 100000],
    mileageRange: [0, 300000],
    yearRange: [1900, 2024],
    isNewCar: false,
    seatsRange: [1, 9],
    doorsRange: [1, 5],
    colors: [],
    caroserie: [],
    transmissions: [],
    fuelTypes: [],
    remarks: "",
    email: "",
    name: "",
    phone: "",
  };

  const theme = useTheme();
  const [formData, setFormData] = useState(() => {
    // Încarcă datele salvate din `sessionStorage` la montare
    const savedData = sessionStorage.getItem("formData");
    return savedData ? JSON.parse(savedData) : initialFormData;
  });

  const [carList, setCarList] = useState([]); // List of added cars
  const [currentCar, setCurrentCar] = useState({ brand: "", model: "" }); // Current selection
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal visibility
  const [isAlertModalOpen, setIsAlertModalOpen] = useState(false); // Modal visibility
  const [responseMessage, setResponseMessage] = useState("");
  const [successStep, setSuccessStep] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");

  const stepRefs = useRef([]);

  const handleNext = () => {
    console.log(formData.selectedCars.length);
    if (formData.selectedCars.length === 0) {
      console.log();
      // Show alert modal or error message
      setErrorMessage(
        "Bitte wählen Sie mindestens ein Auto (Marke und Modell), bevor Sie fortfahren."
      );
      setIsAlertModalOpen(true);
    } else {
      setStep((prev) => prev + 1);
    }
  };
  const handlePrev = () => setStep((prev) => Math.max(prev - 1, 0));

  useEffect(() => {
    // Convertim `formData` în string și îl salvăm
    sessionStorage.setItem("formData", JSON.stringify(formData));
  }, [formData]); // Rulează de fiecare dată când `formData` se schimbă

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
      ...(field === "brands" && { models: [] }), // Reset models if brands change
    }));
  };

  const handleFormSubmit = async () => {
    if (formData.email === "" || formData.name === "") {
      // Show modal with error message
      setErrorMessage(
        "Bitte füge Deine E-Mail-Adresse hinzu. Diese Angabe benötigen wir, um Dir das Angebot zukommen lassen zu können."
      );
      setIsAlertModalOpen(true);
    } else {
      sessionStorage.removeItem("formData");
      sessionStorage.removeItem("step");

      try {
        const response = await axios.post(
          "https://wir-suchen-ihr-auto.ch/backend/api/send-email",
          formData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        setResponseMessage(response.data.status || "Email sent successfully!");
        setSuccessStep(true); // Move to success step
        console.log(responseMessage);
      } catch (error) {
        setResponseMessage(
          error.response?.data.error ||
            "An error occurred while sending the email."
        );
        console.log(responseMessage);
      }
    }
  };

  const addCarToFormData = (brand, model) => {
    setFormData((prev) => ({
      ...prev,
      selectedCars: [...prev.selectedCars, { brand, model }],
    }));
  };

  useEffect(() => {
    // Scroll the current step into view when it changes
    sessionStorage.setItem("step", step);
    if (stepRefs.current[step]) {
      stepRefs.current[step].scrollIntoView({
        behavior: "smooth",
        block: "center", // Center the element in the viewport
      });
    }
  }, [step]);

  const handleBrandChange = (e) => {
    const newBrand = e.target.value;
    setCurrentCar((prev) => ({
      ...prev,
      brand: newBrand,
      model: "", // Reset model when brand changes
    }));
  };

  const handleModelChange = (e) => {
    setCurrentCar((prev) => ({
      ...prev,
      model: e.target.value,
    }));
  };

  const handleAddCar = () => {
    if (currentCar.brand) {
      addCarToFormData(currentCar.brand, currentCar.model);
      setCarList((prev) => [...prev, currentCar]);
      setCurrentCar({ brand: "", model: "" });
      setIsModalOpen(false);
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    // Example regex for a basic phone number (allows digits, spaces, parentheses, dashes)
    const phoneRegex = /^[+]?[0-9\s\-\(\)]{7,15}$/;
    return phoneRegex.test(phone);
  };

  const themeColors = createTheme({
    palette: {
      error: {
        main: "#2f364c", // Example custom error color
      },
      // primary: {
      // main: '#4CAF50', // Example custom primary color
      // },
      // You can customize other colors like secondary, etc.
    },
  });

  return (
    <ThemeProvider theme={themeColors}>
      <div id={"home"}>
        <div
          className="container pt-4"
        >
          {successStep ? (
            <div className="pt-5" style={{ textAlign: "center", height: "calc(100vh - 350px)" }}>
              <h2 className="mb-3">Vielen Dank, dass Sie uns Ihre Wünsche und Anforderungen für Ihr neues Auto mitgeteilt haben.</h2>
              <p className="mb-4 mb-md-5">
                Unser Team macht sich schon an die Arbeit und wird umgehend eine Mailofferte erstellen.
              </p>
              <Button
                variant="contained"
                onClick={() => {
                  setFormData(initialFormData); // Resetează formularul
                  setStep(0); // Înapoi la primul step
                  setSuccessStep(false); // Resetează step-ul de succes
                }}
              >
                Noch eine Anfrage stellen
              </Button>
            </div>
          ) : (
            <>
              <div style={{ marginBottom: "150px" }}>
              {step !== 10 && (
                <Fade in={isVisibleHeader} timeout={1000}>
                  <div className={"container mb-5"}>
                    <div className={"row"}>
                      <div className={"col-12"}>
                        <div
                          className={
                            "d-flex m-auto flex-column justify-content-center align-items-center pb-4 pt-3 pb-sm-5 pt-sm-5"
                          }
                        >
                          <h1 className="home-page-title font40 extraBold text-center">
                            Wir suchen Ihr neues Auto
                          </h1>
                          <p className={"text-center mb-2"}>
                            einfach, schnell und kostenlos - wir ersparen Ihnen
                            die mühsame Sucherei
                          </p>
                          <div className="car car2">
                            <img
                              className={"mirrored"}
                              src={logo}
                              alt={logo}
                              height={"50px"}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Fade>
                )}
                <Fade in={isVisibleHeader} timeout={2000}>
                  <Box sx={{ width: "100%", maxWidth: 800, mx: "auto" }}>
                    {step !== 10 && (
                      <div className="brand_model">
                        <h5 className={"mb-3"}>Marke & Modell</h5>

                        <Box ref={(el) => (stepRefs.current[0] = el)}>
                          {/* Add Car Button */}
                          <Button
                            variant="contained"
                            onClick={() => setIsModalOpen(true)}
                          >
                            Fahrzeug hinzufügen
                          </Button>

                          {/* Modal */}
                          <Modal
                            open={isModalOpen}
                            onClose={() => setIsModalOpen(false)}
                            closeAfterTransition
                            BackdropProps={{
                              timeout: 200,
                            }}
                            aria-labelledby="car-selection-modal-title"
                            aria-describedby="car-selection-modal-description"
                          >
                            <Fade
                              in={isModalOpen}
                              timeout={{ enter: 500, exit: 300 }}
                            >
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: "50%",
                                  left: "50%",
                                  transform: "translate(-50%, -50%)",
                                  p: 5,
                                  maxWidth: 500,
                                  width: "95%",
                                  backgroundColor: "white",
                                  borderRadius: 3,
                                  boxShadow: 24,
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  gap: 2,
                                  // Responsive styles
                                  [theme.breakpoints.down("sm")]: {
                                    p: 4, // Adjust padding for small screens (e.g., mobile)
                                  },
                                }}
                              >
                                <Typography
                                  id="car-selection-modal-title"
                                  variant="h5"
                                  gutterBottom
                                  sx={{ fontWeight: 600 }}
                                >
                                  Marke & Modell
                                </Typography>

                                {/* Brand Selector */}
                                <FormControl fullWidth sx={{ mb: 3 }}>
                                  <InputLabel id="car-brand-label">
                                    Marke
                                  </InputLabel>
                                  <Select
                                    id="car-brand-select" // Add id for linking
                                    labelId="car-brand-label" // Link to InputLabel
                                    value={currentCar.brand}
                                    onChange={handleBrandChange}
                                    label="Marke" // Required for proper label positioning
                                    sx={{
                                      borderRadius: 1.5,
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#bdbdbd", // Lighter border color
                                      },
                                      "&:hover .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "#007bff", // Hover color
                                        },
                                    }}
                                  >
                                    {Object.keys(carModels).map((brand) => (
                                      <MenuItem key={brand} value={brand}>
                                        {brand}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>

                                {/* Model Selector */}
                                <FormControl fullWidth sx={{ mb: 3 }}>
                                  <InputLabel id="car-model-label">
                                    Modell
                                  </InputLabel>
                                  <Select
                                    id="car-model-select" // Add id for linking
                                    labelId="car-model-label" // Link to InputLabel
                                    value={currentCar.model}
                                    onChange={handleModelChange}
                                    label="Modell" // Required for proper label positioning
                                    // disabled={!currentCar.brand} // Disable if no brand selected
                                    sx={{
                                      borderRadius: 1.5,
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#bdbdbd", // Lighter border color
                                      },
                                      "&:hover .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "#007bff", // Hover color
                                        },
                                    }}
                                  >
                                    <MenuItem value={"Alle Modelle"}>
                                      Alle Modelle
                                    </MenuItem>
                                    {(carModels[currentCar.brand] || []).map(
                                      (model) => (
                                        <MenuItem key={model} value={model}>
                                          {model}
                                        </MenuItem>
                                      )
                                    )}
                                  </Select>
                                </FormControl>

                                {/* Add Button */}
                                <Button
                                  variant="contained"
                                  onClick={handleAddCar}
                                >
                                  Fahrzeug hinzufügen
                                </Button>
                              </Box>
                            </Fade>
                          </Modal>

                          {/* Cards */}
                          <div
                            className={
                              "d-flex flex-wrap justify-content-between align-items-center mt-4 mb-3"
                            }
                            style={{
                              marginLeft: "-15px",
                              marginRight: "-15px",
                            }}
                          >
                            {formData.selectedCars.map((car, index) => (
                              <div className={"col-12 col-sm-6 px-3 px-sm-3"}>
                                <Card
                                  key={index}
                                  className={"w-100 mb-4"}
                                  sx={{
                                    // mb: 2,
                                    p: 3,
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    width: "48%",
                                    border: "2px solid #ccc", // Make the border more visible (you can adjust color and width)
                                    borderRadius: "8px", // Optional: rounded corners for a smoother look
                                    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)", // Add a subtle shadow
                                    transition:
                                      "transform 0.3s, box-shadow 0.3s", // Smooth transition for hover effect
                                    "&:hover": {
                                      transform: "scale(1.01)", // Slight scale-up effect on hover
                                      boxShadow:
                                        "0px 4px 10px rgba(0, 0, 0, 0.2)", // Increase shadow on hover
                                    },
                                  }}
                                >
                                  <div>
                                    <div className={"d-flex mb-2"}>
                                      <p className={"me-1"}>
                                        <b>Marke: </b>
                                      </p>
                                      <p>{car.brand}</p>
                                    </div>
                                    <div className={"d-flex"}>
                                      <p className={"me-1"}>
                                        <b>Modell: </b>
                                      </p>
                                      <p>{car.model}</p>
                                    </div>
                                  </div>
                                  <div className={"d-flex flex-column"}>
                                    {/* Edit Button */}
                                    <Button
                                      variant="outlined"
                                      size="small"
                                      sx={{ mb: 1 }}
                                      onClick={() => {
                                        setCurrentCar(car); // Load current car into the modal
                                        setFormData((prev) => ({
                                          ...prev,
                                          selectedCars:
                                            prev.selectedCars.filter(
                                              (_, i) => i !== index
                                            ), // Remove from formData
                                        }));
                                        setIsModalOpen(true); // Open modal for editing
                                      }}
                                    >
                                      Bearbeiten
                                    </Button>
                                    {/* Remove Button */}
                                    <Button
                                      variant="contained"
                                      color="error"
                                      size="small"
                                      onClick={() =>
                                        setFormData((prev) => ({
                                          ...prev,
                                          selectedCars:
                                            prev.selectedCars.filter(
                                              (_, i) => i !== index
                                            ), // Remove from formData
                                        }))
                                      }
                                    >
                                      Entfernen
                                    </Button>
                                  </div>
                                </Card>
                              </div>
                            ))}
                          </div>
                        </Box>
                      </div>
                    )}

                    {/* Step 1: Preis */}
                    {step >= 1 && step !== 10 && (
                      <Fade in={step >= 1} timeout={{ enter: 500, exit: 300 }}>
                        <Box
                          sx={{ py: 5, borderTop: "1px solid #e5e5e5" }}
                          ref={(el) => (stepRefs.current[1] = el)}
                        >
                          <div
                            className={"w-100"}
                            style={{ marginBottom: "20px" }}
                          >
                            <h5 className={"me-auto d-flex"}>Preis</h5>
                            <p>von CHF / bis CHF</p>
                          </div>
                          {/*<Typography className={"me-auto d-flex"} gutterBottom>Preis (CHF)</Typography>*/}
                          <div className={"px-3 w-100"}>
                            <Slider
                              value={formData.priceRange}
                              onChange={(e, newValue) =>
                                handleChange("priceRange", newValue)
                              }
                              valueLabelDisplay="auto"
                              valueLabelFormat={(value) =>
                                `€${value.toLocaleString()}`
                              } // Format the value with a dollar sign and commas
                              min={0}
                              max={100000}
                            />
                          </div>
                          <div className={"d-flex w-100 gap-4"}>
                            {/* Min Value Input */}
                            <TextField
                              label="Min (CHF)"
                              type="number"
                              value={formData.priceRange[0]}
                              onChange={(e) => {
                                const newMin = Math.max(
                                  0,
                                  Number(e.target.value)
                                ); // Ensure min value is >= 0
                                const newMax = Math.max(
                                  newMin,
                                  formData.priceRange[1]
                                ); // Ensure min <= max
                                handleChange("priceRange", [newMin, newMax]);
                              }}
                              sx={{ width: "100%" }}
                              inputProps={{
                                min: 0,
                                style: { height: "16px" }, // Adjust height here
                              }}
                            />
                            {/* Max Value Input */}
                            <TextField
                              label="Max (CHF)"
                              type="number"
                              value={formData.priceRange[1]}
                              onChange={(e) => {
                                const newMax = Math.min(
                                  100000,
                                  Number(e.target.value)
                                ); // Ensure max value is <= 100000
                                const newMin = Math.min(
                                  newMax,
                                  formData.priceRange[0]
                                ); // Ensure min <= max
                                handleChange("priceRange", [newMin, newMax]);
                              }}
                              sx={{ width: "100%" }}
                              inputProps={{
                                min: 0,
                                max: 100000,
                                style: { height: "16px" },
                              }}
                            />
                          </div>
                        </Box>
                      </Fade>
                    )}

                    {/* Step 2: Kilometerstand */}
                    {step >= 2 && step !== 10 && (
                      <Fade in={step >= 2} timeout={{ enter: 500, exit: 300 }}>
                        <Box
                          sx={{ py: 4, borderTop: "1px solid #e5e5e5" }}
                          ref={(el) => (stepRefs.current[2] = el)}
                        >
                          <div
                            className={"w-100"}
                            style={{ marginBottom: "20px" }}
                          >
                            <h5 className={"me-auto d-flex"}>Kilometerstand</h5>
                            <p>von km / bis km</p>
                          </div>
                          <div className={"px-3 w-100"}>
                            <Slider
                              value={formData.mileageRange}
                              onChange={(e, newValue) =>
                                handleChange("mileageRange", newValue)
                              }
                              valueLabelDisplay="auto"
                              min={0}
                              max={300000}
                            />
                          </div>
                          <div className={"d-flex w-100 gap-4"}>
                            {/* Min Value Input */}
                            <TextField
                              label="Min (km)"
                              type="number"
                              value={formData.mileageRange[0]}
                              onChange={(e) => {
                                const newMin = Math.max(
                                  0,
                                  Number(e.target.value)
                                ); // Ensure min value is >= 0
                                const newMax = Math.max(
                                  newMin,
                                  formData.mileageRange[1]
                                ); // Ensure min <= max
                                handleChange("mileageRange", [newMin, newMax]);
                              }}
                              sx={{ width: "100%" }}
                              inputProps={{ min: 0, style: { height: "16px" } }}
                            />
                            {/* Max Value Input */}
                            <TextField
                              label="Max (km)"
                              type="number"
                              value={formData.mileageRange[1]}
                              onChange={(e) => {
                                const newMax = Math.min(
                                  300000,
                                  Number(e.target.value)
                                ); // Ensure max value is <= 300000
                                const newMin = Math.min(
                                  newMax,
                                  formData.mileageRange[0]
                                ); // Ensure min <= max
                                handleChange("mileageRange", [newMin, newMax]);
                              }}
                              sx={{ width: "100%" }}
                              inputProps={{
                                min: 0,
                                max: 300000,
                                style: { height: "16px" },
                              }}
                            />
                          </div>
                        </Box>
                      </Fade>
                    )}

                    {/* Step 3: Jahrgang */}
                    {step >= 3 && step !== 10 && (
                      <Fade in={step >= 3} timeout={{ enter: 500, exit: 300 }}>
                        <Box
                          sx={{ py: 4, borderTop: "1px solid #e5e5e5" }}
                          ref={(el) => (stepRefs.current[3] = el)}
                        >
                          <div
                            className={"w-100"}
                            style={{ marginBottom: "20px" }}
                          >
                            <h5 className={"me-auto d-flex"}>
                              Jahrgang des Fahrzeuges
                            </h5>
                          </div>
                          <div className={"px-3 w-100"}>
                            {/* Slider for Year Range */}
                            <Slider
                              value={formData.yearRange}
                              onChange={(e, newValue) =>
                                handleChange("yearRange", newValue)
                              }
                              valueLabelDisplay="auto"
                              min={1900}
                              max={2024}
                              disabled={formData.isNewCar} // Disable if "New Car" is selected
                            />
                          </div>
                          <div className={"d-flex w-100 gap-4"}>
                            {/* Min Year Input */}
                            <TextField
                              label="Min (Jahre)"
                              type="number"
                              value={formData.yearRange[0]}
                              onChange={(e) => {
                                const newMin = Math.max(
                                  1900,
                                  Number(e.target.value)
                                ); // Ensure min value is >= 1900
                                const newMax = Math.max(
                                  newMin,
                                  formData.yearRange[1]
                                ); // Ensure min <= max
                                handleChange("yearRange", [newMin, newMax]);
                              }}
                              sx={{ width: "100%" }}
                              inputProps={{
                                min: 1900,
                                max: 2024,
                                style: { height: "16px" },
                              }}
                              disabled={formData.isNewCar} // Disable if "New Car" is selected
                            />
                            {/* Max Year Input */}
                            <TextField
                              label="Max (Jahre)"
                              type="number"
                              value={formData.yearRange[1]}
                              onChange={(e) => {
                                const newMax = Math.min(
                                  2024,
                                  Number(e.target.value)
                                ); // Ensure max value is <= 2024
                                const newMin = Math.min(
                                  newMax,
                                  formData.yearRange[0]
                                ); // Ensure min <= max
                                handleChange("yearRange", [newMin, newMax]);
                              }}
                              sx={{ width: "100%" }}
                              inputProps={{
                                min: 1900,
                                max: 2024,
                                style: { height: "16px" },
                              }}
                              disabled={formData.isNewCar} // Disable if "New Car" is selected
                            />
                          </div>
                          {/* Checkbox for New Car */}
                          <div
                            className={"d-flex w-100 align-items-center mt-3"}
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={formData.isNewCar}
                                  onChange={(e) =>
                                    handleChange("isNewCar", e.target.checked)
                                  }
                                />
                              }
                              label={
                                <Box
                                  sx={{
                                    padding: 0,
                                    borderRadius: "4px",
                                    textAlign: "center",
                                    minWidth: "80px",
                                    display: "flex",
                                    gap: "8px",
                                    alignItems: "center",
                                  }}
                                >
                                  <span style={{ marginLeft: "8px" }}>
                                    Neuwagen
                                  </span>
                                </Box>
                              }
                            />
                          </div>
                        </Box>
                      </Fade>
                    )}

                    {/* Step 4: Transmisie Styled as Multi-Select Buttons */}
                    {step >= 4 && step !== 10 && (
                      <Fade in={step >= 4} timeout={{ enter: 500, exit: 300 }}>
                        <Box
                          sx={{ py: 4, borderTop: "1px solid #e5e5e5" }}
                          ref={(el) => (stepRefs.current[4] = el)}
                        >
                          <div
                            className={"w-100"}
                            style={{ marginBottom: "20px" }}
                          >
                            <h5 className={"me-auto d-flex"}>Getriebe</h5>
                          </div>
                          <Box
                            sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}
                          >
                            {transmissions.map((transmission) => (
                              <Box
                                key={transmission}
                                onClick={() => {
                                  // Toggle the selection
                                  const isSelected =
                                    formData.transmissions.includes(
                                      transmission
                                    );
                                  const newTransmissions = isSelected
                                    ? formData.transmissions.filter(
                                        (t) => t !== transmission
                                      ) // Remove if already selected
                                    : [...formData.transmissions, transmission]; // Add if not selected
                                  handleChange(
                                    "transmissions",
                                    newTransmissions
                                  );
                                }}
                                sx={{
                                  padding: "8px 16px",
                                  border: formData.transmissions.includes(
                                    transmission
                                  )
                                    ? "2px solid #2f364c"
                                    : "1px solid #ccc",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  backgroundColor:
                                    formData.transmissions.includes(
                                      transmission
                                    )
                                      ? "#2f364c"
                                      : "white",
                                  color: formData.transmissions.includes(
                                    transmission
                                  )
                                    ? "white"
                                    : "black",
                                  "&:hover": {
                                    borderColor: "#2f364c",
                                  },
                                }}
                              >
                                {transmission}
                              </Box>
                            ))}
                          </Box>
                        </Box>
                      </Fade>
                    )}

                    {/* // Step 6: Kraftstoffart */}
                    {step >= 5 && step !== 10 && (
                      <Fade in={step >= 5} timeout={{ enter: 500, exit: 300 }}>
                        <Box
                          sx={{ py: 4, borderTop: "1px solid #e5e5e5" }}
                          ref={(el) => (stepRefs.current[5] = el)}
                        >
                          <div
                            className={"w-100"}
                            style={{ marginBottom: "20px" }}
                          >
                            <h5 className={"me-auto d-flex"}>Aufbauart</h5>
                          </div>
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}
                          >
                            <div className="row">
                              {Object.keys(caroserieMap).map((key) => (
                                <div key={key} className="col-12 col-md-4 px-3">
                                  {" "}
                                  {/* Bootstrap col-4 to create 3 equal columns */}
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={formData.caroserie.includes(
                                          key
                                        )}
                                        onChange={(e) => {
                                          const newCaroserie = e.target.checked
                                            ? [...formData.caroserie, key]
                                            : formData.caroserie.filter(
                                                (c) => c !== key
                                              );
                                          handleChange(
                                            "caroserie",
                                            newCaroserie
                                          );
                                        }}
                                      />
                                    }
                                    label={
                                      <Box
                                        sx={{
                                          padding: 0,
                                          borderRadius: "4px",
                                          textAlign: "center",
                                          minWidth: "80px",
                                          display: "flex",
                                          gap: "8px",
                                          alignItems: "center",
                                        }}
                                      >
                                        {/* Render SVG content using dangerouslySetInnerHTML */}
                                        <div
                                          className="caroserie-svg"
                                          dangerouslySetInnerHTML={{
                                            __html: caroserieMap[key], // This will render the SVG content
                                          }}
                                        />
                                        {/* Rendering the key (caroserie type) */}
                                        <div className="text-start">{key}</div>
                                      </Box>
                                    }
                                  />
                                </div>
                              ))}
                            </div>
                          </Box>
                        </Box>
                      </Fade>
                    )}

                    {/* Step 5: Plätze & Türen */}
                    {step >= 6 && step !== 10 && (
                      <Fade in={step >= 6} timeout={{ enter: 500, exit: 300 }}>
                        <Box
                          sx={{
                            py: 4,
                            borderTop: "1px solid #e5e5e5",
                          }}
                          ref={(el) => (stepRefs.current[6] = el)}
                        >
                          {/* Header */}
                          <div
                            className={"w-100"}
                            style={{ marginBottom: "20px" }}
                          >
                            <h5 className={"me-auto d-flex"}>Plätze & Türen</h5>
                          </div>

                          {/* Sliders Row */}
                          <div className="row">
                            {/* Slider for Sitzplätze */}
                            <div className="col-12 col-md-6 px-3 mb-3 mb-sm-0">
                              <h5 className={"me-auto d-flex mb-2"}>Plätze</h5>
                              <div className={"px-3 w-100"}>
                                <Slider
                                  value={formData.seatsRange}
                                  onChange={(e, newValue) =>
                                    handleChange("seatsRange", newValue)
                                  }
                                  valueLabelDisplay="auto"
                                  min={1}
                                  max={9}
                                />
                              </div>
                              <div className={"d-flex w-100 gap-4"}>
                                {/* Min Year Input */}
                                <TextField
                                  label="Min (Plätze)"
                                  type="number"
                                  value={formData.seatsRange[0]}
                                  onChange={(e) => {
                                    const newMin = Math.max(
                                      1,
                                      Number(e.target.value)
                                    ); // Ensure min value is >= 1900
                                    const newMax = Math.max(
                                      newMin,
                                      formData.seatsRange[1]
                                    ); // Ensure min <= max
                                    handleChange("seatsRange", [
                                      newMin,
                                      newMax,
                                    ]);
                                  }}
                                  sx={{ width: "100%" }}
                                  inputProps={{
                                    min: 1,
                                    max: 9,
                                    style: { height: "16px" },
                                  }}
                                />
                                {/* Max Year Input */}
                                <TextField
                                  label="Max (Plätze)"
                                  type="number"
                                  value={formData.seatsRange[1]}
                                  onChange={(e) => {
                                    const newMax = Math.min(
                                      2024,
                                      Number(e.target.value)
                                    ); // Ensure max value is <= 2024
                                    const newMin = Math.min(
                                      newMax,
                                      formData.seatsRange[0]
                                    ); // Ensure min <= max
                                    handleChange("seatsRange", [
                                      newMin,
                                      newMax,
                                    ]);
                                  }}
                                  sx={{ width: "100%" }}
                                  inputProps={{
                                    min: 1,
                                    max: 9,
                                    style: { height: "16px" },
                                  }}
                                />
                              </div>
                            </div>

                            {/* Sliders Row */}
                            {/* Slider for Sitzplätze */}
                            <div className="col-12 col-md-6 px-3">
                              <h5 className={"me-auto d-flex mb-2"}>Türen</h5>
                              <div className={"px-3 w-100"}>
                                <Slider
                                  value={formData.doorsRange}
                                  onChange={(e, newValue) =>
                                    handleChange("doorsRange", newValue)
                                  }
                                  valueLabelDisplay="auto"
                                  min={1}
                                  max={5}
                                />
                              </div>
                              <div className={"d-flex w-100 gap-4"}>
                                {/* Min doors Input */}
                                <TextField
                                  label="Min (Türen)"
                                  type="number"
                                  value={formData.doorsRange[0]}
                                  onChange={(e) => {
                                    const newMin = Math.max(
                                      1,
                                      Number(e.target.value)
                                    );
                                    const newMax = Math.max(
                                      newMin,
                                      formData.doorsRange[1]
                                    );
                                    handleChange("doorsRange", [
                                      newMin,
                                      newMax,
                                    ]);
                                  }}
                                  sx={{ width: "100%" }}
                                  inputProps={{
                                    min: 1,
                                    max: 5,
                                    style: { height: "16px" },
                                  }}
                                />
                                {/* Max doors Input */}
                                <TextField
                                  label="Max (Türen)"
                                  type="number"
                                  value={formData.doorsRange[1]}
                                  onChange={(e) => {
                                    const newMax = Math.min(
                                      1,
                                      Number(e.target.value)
                                    );
                                    const newMin = Math.min(
                                      newMax,
                                      formData.doorsRange[0]
                                    );
                                    handleChange("doorsRange", [
                                      newMin,
                                      newMax,
                                    ]);
                                  }}
                                  sx={{ width: "100%" }}
                                  inputProps={{
                                    min: 1,
                                    max: 5,
                                    style: { height: "16px" },
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </Box>
                      </Fade>
                    )}

                    {/* Step 5: Farbe */}
                    {step >= 7 && step !== 10 && (
                      <Fade in={step >= 7} timeout={{ enter: 500, exit: 300 }}>
                        <Box
                          sx={{ py: 4, borderTop: "1px solid #e5e5e5" }}
                          ref={(el) => (stepRefs.current[7] = el)}
                        >
                          <FormControl fullWidth>
                            <InputLabel id="fuel-types-label">
                              Kraftstoffart
                            </InputLabel>
                            <Select
                              labelId="fuel-types-label"
                              id="fuel-types"
                              multiple
                              value={formData.fuelTypes}
                              onChange={(e) =>
                                handleChange("fuelTypes", e.target.value)
                              }
                              input={<OutlinedInput label="Kraftstoffart" />}
                              renderValue={(selected) => (
                                <Box
                                  sx={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                    gap: 0.5,
                                  }}
                                >
                                  {selected.map((value) => (
                                    <Chip
                                      key={value}
                                      label={value}
                                      sx={{
                                        backgroundColor: "#007bff", // Custom background for the chip
                                        color: "#fff", // White text for contrast
                                        borderRadius: "16px", // Rounded corners
                                        "&:hover": {
                                          backgroundColor: "#0056b3", // Darker blue on hover
                                        },
                                      }}
                                    />
                                  ))}
                                </Box>
                              )}
                            >
                              {fuelTypes.map((fuel) => (
                                <MenuItem key={fuel} value={fuel}>
                                  {fuel}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Box>
                      </Fade>
                    )}

                    {/* Step 6: Kraftstoffart */}
                    {step >= 8 && step !== 10 && (
                      <Fade in={step >= 8} timeout={{ enter: 500, exit: 300 }}>
                        <Box
                          sx={{ py: 4, borderTop: "1px solid #e5e5e5" }}
                          ref={(el) => (stepRefs.current[8] = el)}
                        >
                          <div
                            className={"w-100"}
                            style={{ marginBottom: "20px" }}
                          >
                            <h5 className={"me-auto d-flex"}>Farbe</h5>
                          </div>
                          <Box
                            sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}
                          >
                            <div className="row">
                              {Object.keys(colorMap).map((color) => (
                                <div
                                  key={color}
                                  className="col-6 col-md-4 px-3"
                                >
                                  {" "}
                                  {/* Bootstrap col-4 to create 3 equal columns */}
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={formData.colors.includes(
                                          color
                                        )}
                                        onChange={(e) => {
                                          const newColors = e.target.checked
                                            ? [...formData.colors, color]
                                            : formData.colors.filter(
                                                (c) => c !== color
                                              );
                                          handleChange("colors", newColors);
                                        }}
                                      />
                                    }
                                    label={
                                      <Box
                                        sx={{
                                          padding: 0,
                                          borderRadius: "4px",
                                          textAlign: "center",
                                          minWidth: "80px",
                                          display: "flex",
                                          gap: "5px",
                                          alignItems: "center",
                                        }}
                                      >
                                        {/* Circle indicating the color */}
                                        <div
                                          style={{
                                            border: `1px solid ${
                                              color === "Weiss"
                                                ? "#000"
                                                : colorMap[color]
                                            }`,
                                            borderRadius: "50%",
                                            width: "25px",
                                            height: "25px",
                                            backgroundColor: colorMap[color],
                                          }}
                                        />
                                        <div>{color}</div>
                                      </Box>
                                    }
                                  />
                                </div>
                              ))}
                            </div>
                          </Box>
                        </Box>
                      </Fade>
                    )}

                    {/* Step 7: Bemerkungen */}
                    {step >= 9 && step !== 10 && (
                      <Fade in={step >= 9} timeout={{ enter: 500, exit: 300 }}>
                        <Box
                          sx={{ py: 4, borderTop: "1px solid #e5e5e5" }}
                          ref={(el) => (stepRefs.current[9] = el)}
                        >
                          <TextField
                            fullWidth
                            label="Bemerkungen (Optional)"
                            multiline
                            rows={4}
                            value={formData.remarks}
                            onChange={(e) =>
                              handleChange("remarks", e.target.value)
                            }
                          />
                        </Box>
                      </Fade>
                    )}

                    {/* Step 8: */}
                    {step >= 10 && (
                      <Fade in={step >= 10} timeout={{ enter: 500, exit: 300 }}>
                        <Box
                          className={"col-sm-8 mx-auto"}
                          sx={{ py: 4 }}
                          ref={(el) => (stepRefs.current[10] = el)}
                        >
                          {/* Titlu pentru secțiune */}
                          <div
                            className={"w-100"}
                            style={{ marginBottom: "20px" }}
                          >
                            <h2 className={"mb-5 text-center"}>
                              Vervollständige deine Angaben
                            </h2>
                          </div>
                          {/* Name Field */}
                          <TextField
                            className={"mb-4"}
                            label="Name"
                            variant="outlined"
                            fullWidth
                            required
                            onChange={(e) =>
                              handleChange("name", e.target.value)
                            }
                            value={formData.name}
                            sx={{
                              marginBottom: 2,
                            }}
                          />

                          {/* Email Field */}
                          <TextField
                            className={"mb-4"}
                            label="Email"
                            type="email"
                            variant="outlined"
                            fullWidth
                            required
                            error={
                              !validateEmail(formData.email) &&
                              formData.email !== ""
                            }
                            helperText={
                              !validateEmail(formData.email) &&
                              formData.email !== ""
                                ? "Bitte geben Sie eine gültige E-Mail-Adresse ein."
                                : "Diese Angabe benötigen wir, um Dir das Angebot zukommen lassen zu können."
                            }
                            // onChange={(e) => setEmail(e.target.value)} // Handle email change
                            onChange={(e) =>
                              handleChange("email", e.target.value)
                            }
                            value={formData.email}
                            sx={{
                              marginBottom: 2,
                            }}
                          />

                          {/* Optional Phone Number Field */}
                          <TextField
                            label="Telefonnummer (optional)"
                            type="tel"
                            variant="outlined"
                            fullWidth
                            error={
                              formData.phone !== "" &&
                              !validatePhone(formData.phone)
                            } // Show error when invalid
                            helperText={
                              formData.phone !== "" &&
                              !validatePhone(formData.phone)
                                ? "Geben Sie eine gültige Telefonnummer ein."
                                : ""
                            }
                            onChange={(e) =>
                              handleChange("phone", e.target.value)
                            }
                            value={formData.phone}
                            sx={{
                              marginBottom: 2,
                            }}
                          />
                        </Box>
                      </Fade>
                    )}

                    {/* Buttons */}
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        mt: 3,
                      }}
                    >
                      <Button
                        variant="outlined"
                        onClick={handlePrev}
                        disabled={step === 0}
                      >
                        zurück
                      </Button>
                      {step < 10 ? (
                        <Button variant="contained" onClick={handleNext}>
                          Nächster
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          // color="success"
                          onClick={handleFormSubmit}
                          disabled={!validateEmail(formData.email)} // Disable if email is invalid
                        >
                          Sende die Anfrage
                        </Button>
                      )}
                    </Box>
                    <Modal
                      open={isAlertModalOpen}
                      onClose={() => setIsAlertModalOpen(false)}
                      closeAfterTransition
                      BackdropProps={{
                        timeout: 500,
                      }}
                    >
                      <Fade
                        in={isAlertModalOpen}
                        timeout={{ enter: 500, exit: 300 }}
                      >
                        <Box
                          sx={{
                            position: "absolute",
                            top: "50%", // Position from top
                            left: "50%", // Position from left
                            transform: "translate(-50%, -50%)", // Center it exactly
                            p: 4,
                            maxWidth: 400,
                            width: "95%",
                            backgroundColor: "white",
                            borderRadius: 3,
                            boxShadow: 24,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            gap: 2,
                          }}
                        >
                          {/* Close Button (X) */}
                          <IconButton
                            onClick={() => setIsAlertModalOpen(false)}
                            sx={{
                              position: "absolute",
                              top: 8,
                              right: 8,
                              color: "gray",
                              "&:hover": {
                                backgroundColor: "transparent",
                              },
                            }}
                          >
                            <CloseIcon />
                          </IconButton>
                          <ErrorOutlineIcon
                            sx={{ fontSize: "38px", color: "#7374fd" }}
                          />
                          {/*<Typography variant="h6" color="error" gutterBottom>*/}
                          {/*    Error*/}
                          {/*</Typography>*/}
                          <Typography
                            className={"text-center"}
                            variant="body1"
                            color="textSecondary"
                            sx={{ marginBottom: 3 }}
                          >
                            {errorMessage}
                          </Typography>

                          <Button
                            variant="contained"
                            onClick={() => setIsAlertModalOpen(false)}
                          >
                            OK
                          </Button>
                        </Box>
                      </Fade>
                    </Modal>
                  </Box>
                </Fade>
              </div>

              {step !== 10 && (
              <div className="container mb-5">
                <div>
                  <h3 className={"mb-5 text-center"}>
                    Wie funktioniert die Suche Ihres neuen Autos?
                  </h3>
                </div>
                <div className="card-section pb-4 gap-4">
                  <div className="card">
                    <AdsClickIcon
                      className={"mx-auto mb-3"}
                      sx={{ fontSize: "60px", color: "#7374fd" }}
                    />
                    <p>
                      1. Beantworten Sie einpaar kleine Fragen mit Ihren
                      Wünschen sowie Anforderungen an das neue Auto.
                    </p>
                  </div>
                  <div className="card">
                    <SearchIcon
                      className={"mx-auto mb-3"}
                      sx={{ fontSize: "60px", color: "#7374fd" }}
                    />
                    <p>
                      2. Unser professionelles Team sucht im
                      gesamtschweizerischen Händlernetz nach Ihrem perfekten
                      neuen Auto und unterbreitet Ihnen drei persönlich
                      zugeschnittenen Vorschläge,<br></br> alles unverbindlich
                      und komplett transparent.
                    </p>
                  </div>
                  <div className="card">
                    <ThumbUpOffAltIcon
                      className={"mx-auto mb-3"}
                      sx={{ fontSize: "60px", color: "#7374fd" }}
                    />
                    <p>
                      3. Sie wählen Ihren Favoriten aus und wir organisieren
                      alles von der Probefahrt bis hin zum Kauf
                    </p>
                  </div>
                </div>
              </div>
              )}
            </>
          )}
        </div>
      </div>
    </ThemeProvider>
  );
};

export default CarPurchaseForm;
